import { WuiProvider } from '@jwplayer/wui-components/dist/components/wui-provider';
const u = WuiProvider.PUBLIC_UTILS;
export const PUBLIC_UTILS = u;
